import React, { useState, useEffect } from 'react';

// Components
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// Utilities
import moment from 'moment';

const useLogoutTimer = (logoutTime, logout) => {
  const [timeTillLogout, setLogoutTime] = useState(moment().to(logoutTime));

  useEffect(() => {
    const checkForLogout = () => {
      if (logoutTime.diff(moment()) < 10000) logout({ fromURI: 'href' });
    };
    const updateLogoutTime = () => {
      checkForLogout();
      setLogoutTime(moment().to(logoutTime));
    };
    const intervalTimer = setInterval(updateLogoutTime, 5000);
    return () => clearInterval(intervalTimer);
  }, [logoutTime, logout]);

  return timeTillLogout;
};

const SessionExpirationDialog = props => {
  const { time, logout, onClose } = props || {};

  const timeTillLogout = useLogoutTimer(time, logout);

  return (
    <Dialog
      open
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogTitle id="alert-dialog-title">Session Expiring Soon</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Your session is about to expire, and you will be logged out{' '}
          {timeTillLogout}. If you would like to extend your session please
          click 'Extend Session' below.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={logout}>Logout</Button>
        <Button onClick={onClose} color="secondary" autoFocus>
          Extend Session
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionExpirationDialog;
